export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./events-calendar.vue?vue&type=template&id=27767018&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-calendar/events-calendar.vue?vue&type=template&id=27767018&
// module id = 1183
// module chunks = 0